import { render } from "./Regex.vue?vue&type=template&id=628ec9f2&scoped=true"
import script from "./Regex.vue?vue&type=script&lang=js"
export * from "./Regex.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-628ec9f2"

export default script